<template>
  <div>
    <section id="sub_visual" class="pic03">
      <p>이트너스몰 소개</p>
      <span>About etnersmall Service</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con03 clear"> <span class="exr"><img src="../../assets/images/exr_02.png" width="452" height="209" alt=""/></span>
        <h6 class="w50p">더 가깝게,<br/>
          더 신선하게.</h6>
        <span class="ctext1 w50p">이트너스 몰은 해외주재원이 직접 신청한 물품을 구입에서 포장 및 배송까지
      One-Stop 서비스가 가능한 기업복지 솔루션입니다. </span>
        <p class="ctext2 pt"><span class="cbig">Why</span><span>etners mall?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_9.png" width="104" height="104" alt=""/></p>
              <h6>통합 온라인 쇼핑몰</h6>
              <p>몰 사이트를 통해 주재원/교민들이 직접 원하는
                상품을 선택하고 주문할 수 있습니다.</p>
            <li>
              <p><img src="../../assets/images/c_im_10.png" width="104" height="104" alt=""/></p>
              <h6>다양한 식품 도서 제공</h6>
              <p>해외에서 구하기 힘든 1,200여종의 한국 식품 및
                60만점 이상의 도서를 제공하고 있습니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_11.png" width="104" height="104" alt=""/></p>
              <h6>해외 전문배송 루트 확보</h6>
              <p>국제 택배 배송이 어려운 격/오지 국가까지도 이트너스몰 특송을 통하여 배송이 가능합니다. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_12.png" width="104" height="104" alt=""/></p>
              <h6>One Stop서비스</h6>
              <p>상품의 구매부터 포장 통관, 배송의 과정을 이트너스몰에서 지원하며 책임배송하에 안전배송합니다.</p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
        <go-solution :solutionUrl="url" :solCd="solCd" :solGrup="10" :solNm="solNm"></go-solution>
      </section>
    </main>
  </div>
</template>

<script>
  import GoSolution from "../../components/goSolution";
  export default {
    components: {GoSolution},
    data() {
      return{
        url:'http://www.etnersmall.com',
        solNm :'이트너스몰',
        solCd : '2001'
      }
    }
  }

</script>
